// extracted by mini-css-extract-plugin
export default {"profileMain":"ProfilePage_profileMain__bQQzd","profileController":"ProfilePage_profileController__ezO1j","profileControllerRightCol":"ProfilePage_profileControllerRightCol__-kLuS"};